var BiometryStatus;
(function (BiometryStatus) {
    BiometryStatus["DEFAULT"] = "default";
    BiometryStatus["FAILED"] = "failed";
    BiometryStatus["SUCCESS"] = "success";
    BiometryStatus["WAITING"] = "waiting";
})(BiometryStatus || (BiometryStatus = {}));
export { BiometryStatus, };
//# sourceMappingURL=biometry-constants.js.map